/* eslint-disable */
import React, { Component } from 'react';
import Text from '../Styled/Text';
import Headline from '../Styled/Headline';
import Closer from './Closer';

class FAQ extends Component {
  render() {
    return (
      <div>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Headline>Was zeigt die Grafik?</Headline>
        <Text>
          Die Grafik zeigt die Verteilung der Wohnungsgrößen in Deutschland. Die Kurve auf der
          linken Seite repräsentiert die Gesamtbevölkerung: von kleinen Wohnungen (unten) bis großen
          Wohnungen (oben). Wo sich die Kurve erhebt, steigt die Zahl der Menschen mit dieser
          Wohnungsgröße. Auf der rechten Seite ist im Ausgangszustand die prozentuale Verteilung der
          Rentner auf die verschiedenen Wohnungsgrößen abgebildet. Der Nutzer kann weitere
          Teilgruppen auswählen und miteinander vergleichen, zum Beispiel Altersgruppen,
          Haushaltstypen und Bildungsniveaus. Außerdem kann sich der Nutzer selbst in der Grafik
          verorten, indem er seine Wohnungsgröße und die Zahl der Haushaltsmitglieder eingibt. Der
          Schieber in der Grafik rückt dann an die entsprechende Stelle der Verteilung. Zudem wird
          angezeigt, wie viel Prozent der jeweiligen Gruppe mehr und weniger Fläche zur Verfügung
          haben. Das Tool erlaubt zum einen den Vergleich der Wohnfläche eines Haushalts insgesamt
          und zum anderen den Vergleich der Wohnfläche pro Kopf.{' '}
        </Text>
        <Headline>Was ist die mittlere Wohnfläche?</Headline>
        <Text>
          Die mittlere Wohnfläche ist die Wohnfläche, die die Gesamtbevölkerung oder eine Teilgruppe
          in zwei gleich große Gruppen teilt: Die eine Hälfte hat mehr Fläche zur Verfügung, die
          andere weniger. Die mittlere Wohngröße ist verglichen mit der durchschnittlichen
          Wohnfläche robuster gegenüber statistischen Ausreißern.
        </Text>
        <Headline>Wie errechnen sich die Anteile mit mehr und weniger Fläche?</Headline>
        <Text>
          Zunächst wurden die Personen in jeder Vergleichsgruppe nach Wohnfläche aufsteigend
          sortiert und anschließend in 100 gleich große Gruppen unterteilt (Perzentile). Für jedes
          Perzentil wurde die mittlere Wohnfläche (siehe Frage oben) ermittelt. Die Wohnfläche des
          Nutzers wird mit den berechneten mittleren Wohnflächen der Perzentile verglichen. Die
          Perzentile mit höherer mittlerer Wohnfläche werden addiert zum Anteil der Personen mit
          größerer Wohnfläche, die Perzentile mit geringerer mittlerer Wohnfläche zum Anteil der
          Personen mit kleinerer Wohnfläche.
        </Text>
        <Headline>Auf welchen Daten basiert die Auswertung?</Headline>
        <Text>
          Die Berechnungen basieren auf Daten des Sozio-oekonomischen Panels (SOEP). Das SOEP ist
          eine seit 1984 durchgeführte repräsentative Wiederholungsbefragung in Deutschland von
          aktuell rund 38.000 Personen aus mehr als 14.000 Haushalten. Aktuell sind die SOEP-Daten
          bis zum Jahr 2018 verfügbar.
        </Text>
        <Headline>Was zeigen die Kurven in der Grafik?</Headline>
        <Text>
          Die Kurven zeigen den geglätteten Verlauf der Wohnflächenverteilung. Grundlage sind die
          Bevölkerungsanteile für jeden 5-Quadratmeter-Abschnitt auf der vertikalen Skala für die
          Wohnfläche. Wenn beispielsweise 15 Prozent der Bevölkerung zwischen 80 und 85 Quadratmeter
          Fläche bewohnen, so wird die Kurve in diesem Abschnitt die 15 Prozent schneiden, in Teilen
          aber darüber und darunter verlaufen. Ähnlich wie bei der Schätzung einer
          Kerndichtefunktion wird die diskrete Verteilung der Wohnflächen mittels einer Kurve
          geglättet und in eine gleichmäßige, stetige Verteilung umgewandelt. Während sich die
          Anteile der Bevölkerung in den 5-Quadratmeter-Bandbreiten einfach in Prozent ausdrücken
          lassen, steht bei der Dichtefunktion die Fläche unterhalb der Kurve im Vordergrund und
          gibt die Wahrscheinlichkeit an, mit der eine bestimmte Wohnfläche beobachtet wird. Die
          gesamte Fläche unter der Kurve repräsentiert immer 100 Prozent der betrachteten Gruppe.
        </Text>
        <Headline>Warum werden die Flächen im oberen Bereich größer?</Headline>
        <Text>
          Die vertikale Skala verläuft in 5-Quadratmeter-Abschnitten zunächst von 0 bis 300. Weil ab
          einer bestimmten Wohnfläche nur sehr wenige Menschen in einen 5-Quadratmeter-Abschnitt
          fallen, dafür aber einige Menschen in sehr große Wohnungen leben, sind alle Wohnungen mit
          einer Größe von mehr als 300 Quadratmetern in einem einzigen Abschnitt zusammengefasst.
          Damit wird verhindert, dass die Skala sehr lang und die Grafik unübersichtlich wird.
          Allerdings schwillt die Kurve dadurch am oberen Ende an, was sie bei gleichbleibenden
          Quadratmeter-Schritten nicht tun würde.
        </Text>
        <Headline>Wie setzt sich die Gruppe mit Wohneigentum zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen, die in einer Wohnung wohnen, die entweder ihnen
          selbst oder mindestens einer Person im Haushalt gehört.{' '}
        </Text>
        <Headline>Wie setzt sich die Gruppe mit Migrationshintergrund zusammen?</Headline>
        <Text>
          Zu den Menschen mit Migrationshintergrund zählen alle nach 1949 auf das heutige Gebiet der
          Bundesrepublik Deutschland Zugewanderten sowie alle in Deutschland Geborenen mit
          mindestens einem zugewanderten oder als Ausländer in Deutschland geborenen Elternteil.
        </Text>
        <Headline>Wie setzt sich die Gruppe ohne Ausbildung zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören Personen mit maximal mittlerem Schulabschluss und ohne
          Berufsausbildung. Dazu zählen Personen mit Hauptschulabschluss ohne berufliche Ausbildung,
          mit mittlerer Reife ohne berufliche Ausbildung sowie Personen, die weder über einen
          allgemeinbildenden noch über einen beruflichen Abschluss verfügen. Personen mit
          Hochschulzugangsberechtigung gehören nicht zu dieser Gruppe, unabhängig davon, ob sie eine
          berufliche Ausbildung absolviert haben oder nicht.
        </Text>
        <Headline>Wie setzt sich die Gruppe mit Hochschulabschluss zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen mit abgeschlossenem Studium an einer Fachhochschule
          oder Universität.
        </Text>
        <Headline>Wie setzen sich die Gruppen Vollzeit und Teilzeit zusammen?</Headline>
        <Text>
          Eine Vollzeittätigkeit entspricht einer durchschnittlichen Wochenarbeitszeit von
          mindestens 35 Stunden. Als Teilzeit-Erwerbstätiger gilt in dieser Betrachtung, wer
          regelmäßig mehr als 1 und weniger als 35 Wochenarbeitsstunden leistet.
        </Text>
        <Headline>Wie setzt sich die Gruppe der Rentner zusammen?</Headline>
        <Text>
          Zu dieser Gruppe gehören alle Personen, die eine gesetzliche Rente beziehen und
          gleichzeitig älter als 60 Jahre sind. Die Rente kann durch Erwerbseinkommen ergänzt
          werden.
        </Text>
        <Headline>Was ist das Haushaltsnettoeinkommen?</Headline>
        <Text>
          Das Haushaltsnettoeinkommen umfasst die monatlichen Einkommen aller Haushaltsmitglieder
          vor Abzug der Sozialversicherungsbeiträge und der direkten Steuern wie der
          Einkommensteuer. Zum Einkommen zählen Löhne, Einkommen aus selbstständiger Arbeit, Zinsen,
          Mieteinnahmen, Renten und staatliche Transferleistungen wie beispielsweise
          Arbeitslosengeld und Kindergeld. Zudem wird bei Haushalten mit Wohneigentum der jährliche
          Nettomietwert des selbstgenutzten Wohneigentums als zusätzlicher Einkommensbestandteil
          berücksichtigt.
        </Text>
      </div>
    );
  }
}

export default FAQ;
